import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import "../css/BannerInfo.css";

// import ChatIcon from "../img/chatIcon.svg";
// import AutismHeart from "../img/autism-heart.png";
// import WomanAndBoy from "../img/boyAndWoman.png";
// import WomanAndGirl from "../img/girlAndWoman.png";
// import HandAndHeart from "../img/hand-and-heart.png";
// import BoyAndMan from "../img/childAndMan.png";

const BannerInfo = () => {
  return (
    <Container fluid className="banner_info_container banner_info_lines_parent">
      <Row className="banner_info_lines row_1 justify-content-center text-center mb-1">
        <Col xs={12} md={8} lg={6}>
          <h3>About Kickin' Cancer Foundation</h3>
        </Col>
      </Row>
      <Row className="banner_info_lines row_1 justify-content-center text-center mt-sm-n0 mt-md-n4">
        <Col sm={12} md={10} lg={8}>
          <h4>
            <a
              href="https://kicking-cancer.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="banner_info_kickin_link"
            >
              Kickin' Cancer Foundation was established in 2009 and it has been
              working ever since to provide support to people dealing with
              cancer by organizing various fundraisers for time to time.
            </a>
            <br /> At Sun West, we are committed to lending a hand to our
            customers, colleagues, business partners and neighbors in the
            communities we serve. We recognize the valuable impact the Kickin'
            Cancer Foundation has on our local communities. 
            {/* To show our gratitude, we're providing a $1,200 lender's credit to Kickin'
            Cancer Foundation members, stakeholders and family members or
            friends of Kickin' Cancer Employees who close on a home loan with
            us. */}
          </h4>
        </Col>
      </Row>
    </Container>
  );
};

export default BannerInfo;
